export default {
    keyField: 'ID',
    textField: 'promoText',
    priceField: 'price',
    quantityField: 'quantity',
    extraUnitsField: 'extra',
    imageField: 'imageURL',
    productsField: 'products\r'
}